<app-main-header *transloco="let t">{{t('change-password')}}</app-main-header>
<app-change-known-password></app-change-known-password>
